.titleBarContainer {
    container-name: title-bar-container;
    container-type: inline-size;
    /* magic-numbering the container to line it up with the sidebar */
    margin-top: calc(-1 * var(--exo-spacing-large));
}

.titleBar {
    display: flex;
    flex-flow: row wrap;
    align-content: center;
    gap: var(--exo-spacing-small);
    padding: var(--exo-spacing-standard);
    background-color: var(--exo-color-body);
    border: 1px solid var(--exo-color-background-tertiary);
    border-radius: var(--exo-radius-large);
    margin-bottom: var(--exo-spacing-standard);
    min-height: var(--exo-spacing-3x-large);
}

@container title-bar-container (min-width: 600px) {
    .titleBar {
        /* keep the bar from changing height between modes */
        height: var(--exo-spacing-3x-large);
    }
}

.errorBanner[open] + .titleBar {
    margin-top: var(--exo-spacing-standard);
}

.name {
    font: var(--exo-text-body-bold);
    color: var(--exo-color-font);
    width: fit-content;
    max-width: 42ch;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.idpName::part(badge) {
    border-color: var(--exo-color-border-tertiary);
}

/* hiding Exo input validation messages to prevent layout jumps */
.nameInput::part(form-control-invalid-text) {
    display: none;
}

/* Force the IDP select dropdown to open below the input. */
/* Extra specificity needed to beat Exosphere */
.titleBar .idpSelect::part(select-menu-popup) {
    position: absolute;
    /* biome-ignore lint/complexity/noImportantStyles: Exosphere adds "top" directly to element, so !important is required */
    top: 100% !important;
}

.backButton,
.editButton,
.deleteButton {
    cursor: pointer;
}

.statusToggle {
    margin-left: auto;
}

.actionButtons {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: var(--exo-spacing-small);
    margin-left: auto;
}

.deleteMessage {
    font: var(--exo-text-body-medium);
}
